export const Errors = ({ _errors = [] }: { _errors?: string[] }) => {
  if (_errors.length === 0) return null
  return (
    <div className="flex items-center !text-sm mt-1  text-red-500 opacity-90 !pt-1">
      <span>{_errors[0]}</span>
    </div>
  )
}
